import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { updateChildrenWithParentId } from "../../../../Components/Tree/TreeUtils";
import type { TreeNode } from "../../../../Components/Tree/types";
import { GET_ACTUAL_STATUS_VALUES } from "./StatusesApi";

interface ActualStatusValuesData {
  finding_filter_data?: {
    values?: string[];
    field?: string;
  };
}

interface UseStatusesReturn {
  statuses: TreeNode[] | null;
}

const useStatuses = (): UseStatusesReturn => {
  const [statuses, setStatuses] = useState<TreeNode[] | null>(null);
  const { data } = useQuery<ActualStatusValuesData>(GET_ACTUAL_STATUS_VALUES);

  useEffect(() => {
    if (!!data) {
      const treeNodes = data?.finding_filter_data?.values?.map((item) => {
        return {
          ...JSON.parse(item),
        } as TreeNode;
      });

      const tree: TreeNode[] = [
        {
          type: "root",
          name: "root",
          id: "root",
          children: treeNodes,
        },
      ];
      setStatuses(updateChildrenWithParentId(tree, null));
    }
  }, [data]);

  return { statuses };
};

export default useStatuses;
